import RailsResource from './rails-resource';

class PipelineService extends RailsResource {
  constructor() {
    super({
      url: '/admin/crm',
      resource: 'pipelines',
      ajaxLoader: false
    });
  }

  stages(id) {
    return this.call(`${this.url}/${this.resource}/${id}/stages.json`);
  }
}

export default new PipelineService();
